export default {
explore_by: "explore by",
explore_by_concepts: "ideas",
explore_by_families: "scent families",
language: "language",
legal: "legal",
find_any_fragrance: "find any fragrance in the world.",
title_by_concepts: "explore by ideas",
desc_by_concepts: "find your fragrance by thinking on your favorite color or place",
title_by_families: "explore by families",
desc_by_families: "find your fragrance by thinking on ...",
expert_reviewed: "expert reviewed",
ingredients: "ingredients",
description: "description",
perfumist: "perfumer",
concepts: "concepts",
olfactive_family: "olfactive family",
main_family: "family",
sub_family: "subfamily",
me_family: "Fragrances of the World",
filter_by_family: "families",
filter_by_brand: "brands",
filter_by_gender: "gender",
for_him: "For him",
for_her: "For her",
unisex: "Unisex",
all: "All",
all_female: "All",
concepts_list: "Concepts list",
no_results_for_this_combination: "No perfumes for this combination.",
select_at_least_one_concept: "Select at least one concept",
view_perfumes: "View perfumes",
back: "Go Back",
close: "Close",
filters: "Filters",
selected_concepts: "Selected concepts:",
selected_families: "Selected families:",
find_concept: "Find concepts...",
smell_of: "Smell of",
touch_of: "With a touch of",
loading_perfumes: "loading perfumes",
loading_concepts: "loading concepts",
apply: "apply",
search: "search",
clear_all: "clear all",
iconic_fragrances: "Iconic fragrances in this family",
is_there_anybody_here: "Are You Still Here?",
continue_previous_session: "Yes! Lets Continue",
reset_session: "Restart The Experience",
ingredient_type: "Type",
ingredient_parts: "Part(s) used",
ingredient_extraction: "Extraction method",
ingredient_first: "Iconic perfume",
history: "History",
effect: "Production & Effect",
origin: "Origin",
iconic_fragrance: "Iconic fragrance",
production: "Production",
loyalty_become_a_member: "Join the Club",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"  
}
